module.exports = __webpack_public_path__ + "static/media/capsule_machine.bd602a87.png";